import styled from 'styled-components'

export const UncontrolledDropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`
